import { useEffect } from 'react';
import AnalyticsService from '../services/analytics/analyticsService';
import { EventName } from '../services/analytics/providers/analyticsProvider';
import ZendeskService from '../services/zendeskService';

function getCookieYesConsentRange(): 'all' | 'functional' | 'none' | null {
  const cookieYes = (window as Window & { getCkyConsent?: () => { categories?: Record<string, boolean> } })
    .getCkyConsent;

  if (!cookieYes) {
    return null;
  }

  const consent = cookieYes();
  const categories = consent?.categories;

  if (!categories) {
    return null;
  }

  // necessary is almost always true once any consent exists — do not treat it as
  // functional. Map only explicit category choices to Zendesk cookie ranges.
  if (categories.analytics) {
    return 'all';
  }

  if (categories.functional) {
    return 'functional';
  }

  return 'none';
}

function syncZendeskCookies(): void {
  const range = getCookieYesConsentRange();

  if (range) {
    ZendeskService.setCookies(range);
  }
}

function ZendeskBootstrap() {
  useEffect(() => {
    // CSS-hide launcher + wait for snippet. Do not call messenger show/hide/open here —
    // show was opening the chat panel on page load.
    void ZendeskService.warm()
      .then(() => {
        syncZendeskCookies();
      })
      .catch((error: unknown) => {
        AnalyticsService.trackError(EventName.UNKNOWN_ERROR, error, {
          source: 'zendesk.warm',
        });
      });

    const handleConsentUpdate = () => {
      syncZendeskCookies();
    };

    document.addEventListener('cookieyes_consent_update', handleConsentUpdate);

    return () => {
      document.removeEventListener('cookieyes_consent_update', handleConsentUpdate);
    };
  }, []);

  return null;
}

export default ZendeskBootstrap;
